// extracted by mini-css-extract-plugin
module.exports = {"heading":"gift-card-image-grid-header_heading__jByVv","content":"gift-card-image-grid-header_content__cXDGx"};